import { useEffect, useState } from "react";
import MUITable from "../../../Common/MUITable";
import isGHMC from "../../../Common/helper/helpar";
import { AddEditEmployee } from "./AddEditEmployeeModal";
import { GetDesignations, GetEmployees, GetIdentityTypes, GetOperations } from "../AttendanceApis";
import { Col, Row } from "react-bootstrap";
import { GetCircle, GetZone } from "../../../Apis/organizationApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { ExportEmployee } from "./ExportEmployee";
import Loader from "../../../Common/Loader/loader";
import { AllShiftMaster } from "../../../Apis/shiftMasterApi";
import { GetAllAssociatedTransferStations } from "../../../Apis/transferStationApi";
import { canWritePermission } from "../../../Common/helper/helpar";

const Employee = () => {
    const isProd = isGHMC();
    const [employeeData, setEmployeeData] = useState([]);
    const [zoneData, setZoneData] = useState([]);
    const [circleData, setCircleData] = useState([]);
    const [showAddEditEmployeeModal, setShowAddEditEmployeeModal] = useState(false);
    const [editEmployeeData, setEditEmployeeData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isEditEmployee, setIsEditEmployee] = useState(false);
    const [operationsData, setOperationsData] = useState([]);
    const [designationsData, setDesignationsData] = useState([]);
    const [identityTypesData, setIdentityTypesData] = useState([]);
    const [shiftsData, setShiftsData] = useState([]);
    const [transferStationsData, setTransferStationsData] = useState([]);
    const [filterData, setFilterData] = useState({
        ZoneId: "",
        CircleId: "",
        IsActive: "",
    });
    const [canWriteValue, setCanWriteValue] = useState(null);

    useEffect(() => {
        setCanWriteValue(canWritePermission("Employee"));
    },[] )

    const fetchInitialDropdowns = async () => {
        setIsLoading(true)
        try {
            const [
                ZoneResponse,
                CircleResponse,
                OperationsResponse,
                DesignationsResponse,
                IdentityTypesResponse,
                ShiftsResponse,
                TransferStationsResponse,
            ] = await Promise.all([
                GetZone(),
                GetCircle(),
                GetOperations(),
                GetDesignations(),
                GetIdentityTypes(),
                AllShiftMaster(),
                GetAllAssociatedTransferStations(),
            ]);
            setZoneData(ZoneResponse);
            setCircleData(CircleResponse);
            setOperationsData(OperationsResponse.data);
            setDesignationsData(DesignationsResponse.data);
            setIdentityTypesData(IdentityTypesResponse.data);
            setShiftsData(ShiftsResponse);
            setTransferStationsData(TransferStationsResponse);
        } catch (error) {
            console.error("Error fetching Route data:", error.message);
        } finally {
            setIsLoading(false)
        }
    }

    const fetchEmployee = async () => {
        setIsLoading(true);
        try {
            const EmployeeResponse = await GetEmployees(filterData);
            setEmployeeData(EmployeeResponse?.data);
        } catch (error) {
            console.error("Error fetching Route data:", error.message);
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        fetchInitialDropdowns();
        fetchEmployee();
    }, [])

    const employeeColumns = [
        {
            label: "Employee ID",
            field: "employeeId",
        },
        {
            label: "Employee Name",
            field: "employeeName",
        },
        {
            label: "Operation",
            field: "operationName",
            width: 150
        },
        {
            label: "Designation",
            field: "designationName",
            width: 150
        },
        {
            label: "Zone",
            field: "zoneName",
            width: 100
        },
        {
            label: "Circle",
            field: "circleName",
            width: 120
        },
        {
            label: "Transfer Station",
            field: "transferStationName",
            width: 120
        },
        {
            label: "Gender",
            field: "gender",
        },
        {
            label: "Contact No",
            field: "contactNo",
        },
        {
            label: "Shift",
            field: "shiftName",
        },
        {
            label: "Status",
            field: "isActive",
            render: (row) => row.isActive ? "Active" : "InActive",
        },
        {
            label: "Edit",
            render: (row) => <button
                className={`${isProd ? "edit-ghmc" : "edit-swm"}`}
                onClick={() => { setEditEmployeeData(row); setShowAddEditEmployeeModal(true); setIsEditEmployee(true) }}
            >
                <FontAwesomeIcon icon={faEdit} />
            </button>,
        },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilterData({
            ...filterData,
            [name]: value,
        });
    };

    const handleFilters = async (e) => {
        e.preventDefault();
        fetchEmployee();
    }

    const filterResetHandler = async () => {
        fetchEmployee();
    }

    return (
        <>
            {isLoading && <Loader />}
            <div className="content text-start">
                <div className="page-content">
                    <div className="my-3 d-flex justify-content-end gap-2">
                        {canWriteValue ?
                            <button className="button-container" onClick={() => { setShowAddEditEmployeeModal(true); setIsEditEmployee(false) }}>
                                <i className="fa-solid fa-plus me-1 icon-container"></i>
                                Add Employee
                            </button>
                            : ""}
                        <ExportEmployee employeeData={employeeData} />
                    </div>
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={handleFilters}>
                                <Row className="align-items-center rounded">
                                    <Col md="6" lg="3">
                                        <select
                                            name="ZoneId"
                                            id="ZoneId"
                                            className="form-select"
                                            value={filterData.ZoneId}
                                            onChange={handleChange}
                                        >
                                            <option value="" >
                                                Select Zone
                                            </option>
                                            {zoneData
                                                .filter((zone) => zone.isActive)
                                                ?.map((zone) => (
                                                    <option key={zone.zoneId} value={zone.zoneId}>
                                                        {zone.zoneName}
                                                    </option>
                                                ))}
                                        </select>
                                    </Col>
                                    <Col md="6" lg="3">
                                        <select
                                            name="CircleId"
                                            id="CircleId"
                                            className="form-select"
                                            value={filterData.CircleId}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Circle</option>
                                            {circleData && circleData
                                                .filter((circle) => circle.isActive && circle.zoneId == filterData.ZoneId)
                                                .map((circle) => (
                                                    <option key={circle.circleId} value={circle.circleId}>{circle.circleName}</option>
                                                ))}
                                        </select>
                                    </Col>
                                    <Col md="6" lg="3">
                                        <select
                                            name="IsActive"
                                            id="IsActive"
                                            className="form-select"
                                            value={filterData.IsActive}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Status</option>
                                            <option value="true">Active</option>
                                            <option value="false">InActive</option>
                                        </select>
                                    </Col>
                                    <Col md="6" lg="3" className="d-flex gap-2">
                                        <button
                                            type="submit"
                                            className={`btn  search ${isProd ? "search-ghmc" : "search-swm"}`}
                                        >
                                            Search
                                        </button>
                                        {/* <button 
                                            type="reset" 
                                            className="button-container"
                                            onClick={filterResetHandler}
                                        >
                                            Reset
                                        </button> */}
                                    </Col>
                                </Row>
                            </form>
                            <div class="top-header text-center mt-3">
                                <span>Employee Details</span>
                            </div>
                            <MUITable
                                needSRNumber
                                columns={employeeColumns}
                                rows={employeeData && employeeData}
                                tableHeight={500}
                            />
                        </div>
                    </div>
                </div>
            </div >
            <AddEditEmployee
                zoneData={zoneData}
                circleData={circleData}
                showModal={showAddEditEmployeeModal}
                closeModal={() => setShowAddEditEmployeeModal(false)}
                editData={editEmployeeData}
                isEditEmployee={isEditEmployee}
                setIsEditEmployee={setIsEditEmployee}
                fetchEmployee={fetchEmployee}
                operationsData={operationsData}
                designationsData={designationsData}
                identityTypesData={identityTypesData}
                shiftsData={shiftsData}
                transferStationsData={transferStationsData}
                canWriteValue={canWriteValue}
            />
        </>
    )
}

export default Employee;